/* eslint-disable import/prefer-default-export */
import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';

export const fetchUserInfo = (TYPE) => (appName) =>
    createAction(TYPE, createRequestPayload('identityGateway', `/user-info/${appName}`));
